import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedAdminRoute = ({ children }) => {
  const { loading, isAuth,user,isAdmin } = useSelector((state) => state.Users);
  if (loading === false) {
    if (!isAuth) {
      return <Navigate to="/login" replace />;
    } else if(user.role !== "admin"){
        return <Navigate to="/" replace />;
    }
    return children;
  }
};

export default ProtectedAdminRoute;